import React, { useState, useEffect, useCallback } from "react";
import { getRequest } from "../apis/ApiInstence";

const Hero = () => {
  const [current, setCurrent] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [slides, setSlides] = useState([]);

  const backendUrl = (process.env.REACT_APP_BACKEND || 'http://localhost:8000').replace(/\/+$/, '');

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await getRequest('/herobanners');
        const data = Array.isArray(res?.data) ? res.data : [];
        setSlides(data);
      } catch {
        setSlides([]);
      }
    };
    fetchBanners();
  }, []);

  const len = slides.length;

  const goTo = useCallback(
    (index) => {
      if (isTransitioning) return;
      setIsTransitioning(true);
      setCurrent((index + len) % len);
      setTimeout(() => setIsTransitioning(false), 700);
    },
    [isTransitioning, len]
  );

  const next = useCallback(() => goTo(current + 1), [current, goTo]);
  const prev = useCallback(() => goTo(current - 1), [current, goTo]);

  useEffect(() => {
    if (!isAutoPlaying) return;
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [isAutoPlaying, next]);

  if (slides.length === 0) return null;

  return (
    <section
      className="relative w-full select-none group"
      onMouseEnter={() => setIsAutoPlaying(false)}
      onMouseLeave={() => setIsAutoPlaying(true)}
    >
      <style>{`
        .hero-img {
          width: 100%;
          height: auto;
          display: block;
          transition: opacity 0.7s ease, transform 0.7s ease;
        }
        .hero-img.active {
          opacity: 1;
          transform: scale(1);
          position: relative;
          z-index: 10;
        }
        .hero-img.inactive {
          opacity: 0;
          transform: scale(1.04);
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 5;
        }
        .hero-dot {
          transition: all 0.3s ease;
        }
        @media (hover: hover) {
          .hero-arrow-btn {
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.3s ease, transform 0.3s ease;
          }
          .group:hover .hero-arrow-btn {
            opacity: 1;
            pointer-events: auto;
          }
        }
        @media (hover: none) {
          .hero-arrow-btn {
            opacity: 1;
            pointer-events: auto;
          }
        }
      `}</style>

      {/* [Backup] original without container: <div className="relative">...</div> */}
      <div className="mx-auto max-w-9xl 2xl:max-w-10xl">
        <div className="relative">
          {slides.map((slide, i) => (
            <img
              key={slide.id || i}
              src={`${backendUrl}/uploads/herobanner/${slide.image}`}
              alt={slide.name || `Slide ${i + 1}`}
              draggable={false}
              className={`hero-img ${i === current ? "active" : "inactive"}`}
            />
          ))}
        </div>
      </div>

      <button
        onClick={prev}
        aria-label="Previous slide"
        className="hero-arrow-btn absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 z-30 w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-black/40 backdrop-blur-sm border border-white/20 flex items-center justify-center text-white/80 hover:bg-white/25 hover:text-white hover:scale-110 transition"
      >
        <i className="fas fa-chevron-left text-xs sm:text-sm"></i>
      </button>
      <button
        onClick={next}
        aria-label="Next slide"
        className="hero-arrow-btn absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 z-30 w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-black/40 backdrop-blur-sm border border-white/20 flex items-center justify-center text-white/80 hover:bg-white/25 hover:text-white hover:scale-110 transition"
      >
        <i className="fas fa-chevron-right text-xs sm:text-sm"></i>
      </button>

      <div className="absolute bottom-3 sm:bottom-5 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2 sm:gap-2.5">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
            className="hero-dot rounded-full"
            style={{
              width: i === current ? "24px" : "7px",
              height: "7px",
              backgroundColor: i === current ? "#F36F21" : "rgba(255,255,255,0.5)",
            }}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
